// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2QyqP","productName":"Table_productName__1S3Y6"};